import { render, staticRenderFns } from "./umatIstri.vue?vue&type=template&id=b00b5216&scoped=true&"
import script from "./umatIstri.vue?vue&type=script&lang=js&"
export * from "./umatIstri.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./umatIstri.vue?vue&type=style&index=1&id=b00b5216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00b5216",
  null
  
)

export default component.exports